@if (value()) {
	<span
		class="flex text-[0.625rem] font-semibold h-4 justify-center leading-[1.3] min-w-4.5 w-fit items-center select-none whitespace-nowrap border rounded-lg pt-[0.5px] pb-px px-1.5"
		data-cy="ui-pill"
		[ngClass]="classes()"
	>
		@if (icon()) {
			<ui-icon class="mr-1" [icon]="icon()" size="2xs"></ui-icon>
		}
		{{ value() }}
	</span>
}
